import styled from '@emotion/styled';
import { getColor } from '../../../common/UICommon';
import { TabletWidth } from '../../../../global.style';
import darkGreenAbstractShape from '../../../../assets/darkGreenAbstractShape.webp';

export const ProgramV2CardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 33px;

  @media (max-width: ${TabletWidth}px) {
    flex-direction: column;
  }
`;

export const ProgramV2Container = styled.div<{ enabled: boolean }>`
  width: 327px;
  border-radius: 34px;
  border: ${({ enabled }) => (enabled ? `4px solid #d0f972` : '4px solid transparent')};

  &:hover {
    cursor: pointer;
  }
`;

export const ProgramV2PriceWrapperImage = styled.div`
  background-image: url(${darkGreenAbstractShape});
  mix-blend-mode: multiply;
  background-position: 50%;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 32px;
  overflow: hidden;
`;

export const ProgramV2PriceWrapper = styled.div`
  padding: 17px 16px 20px 20px;
`;

export const ProgramV2Header = styled.div`
  background: rgba(0, 0, 0, 0.6);
  border-top-right-radius: 32px;
  border-top-left-radius: 32px;
  `;
  
  export const ProgramV2HeaderText = styled.div`
  color: ${getColor('WHITE')};
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  padding: 17px 22px;
`;

export const ProgramV2Price = styled.div`
  display: flex;
  flex-direction: row;
  opacity: 0.8;
  justify-content: space-between;
  align-items: center;
`;

export const ProgramV2PriceLabel = styled.div`
  color: #d0f972;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px;
`;

export const ProgramV2PriceMonthWrapper = styled.div`
  color: #d0f972;
  display: flex;
  flex-direction: row;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  align-items: baseline;
`;

export const ProgramV2PriceValue = styled.div`
  font-family: Poppins;
  font-size: 48px;
  font-style: normal;
  font-weight: 400;
  line-height: 56px;
`;

export const ProgramV2PriceMonth = styled.div`
  color: #d0f972;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
`;

export const ProgramV2PriceTotal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: ${getColor('WHITE')};
  padding: 7px 0 17px;
  border-bottom: 0.5px solid #e6f1e478; /* 47% opacity */
`;
export const ProgramV2PriceTotalTitle = styled.div`
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 7px;
  margin-bottom: 8px;
`;

export const ProgramV2PriceTotalSubtitle = styled.div`
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px;
`;
export const ProgramV2PriceDetails = styled.div<{ paddingTop: number }>`
  color: ${getColor('WHITE')};
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
  ${({ paddingTop }) => `padding-top: ${paddingTop}px;`}
`;

export const ProgramV2PriceImage = styled.img`
  vertical-align: middle;
  width: 33px;
  height: 13px;
  margin-left: 2px;
`;

export const ProgramV2BulletsWrapper = styled.div`
  padding: 28px 24px 24px 20px;
  background-color: ${getColor('BEIGE_5')};
  border-bottom-right-radius: 32px;
  border-bottom-left-radius: 32px;
`;
